import { MenuPageShell } from '@/components/printMenu/MenuPageShell'
import { SectionDividerTitle } from '@/components/printMenu/SectionDividerTitle'

type SectionDividerPageProps = {
  title: string
  subtitle?: string
  pageNumber: number
  totalPages: number
}

export function SectionDividerPage({ title, subtitle, pageNumber, totalPages }: SectionDividerPageProps) {
  return (
    <MenuPageShell pageNumber={pageNumber} totalPages={totalPages}>
      <div className="flex flex-1 flex-col items-center justify-center text-center">
        <div className="mx-auto mb-12 h-px w-20 bg-hairline" aria-hidden />
        <SectionDividerTitle title={title} />
        {subtitle ? (
          <p className="mt-6 font-display text-[length:var(--menu-fs-lg)] italic text-muted">{subtitle}</p>
        ) : null}
        <div className="mx-auto mt-12 h-px w-20 bg-hairline" aria-hidden />
      </div>
    </MenuPageShell>
  )
}
